export default __webpack_public_path__ + "static/media/logo.7326c0d9.svg";